import { Theme } from "@mui/material/styles";

export const mapConsumptionToProgressColor = (
  percentageRemaining: number,
  theme: Theme,
) => {
  if (percentageRemaining <= 0) {
    return theme.palette.error.light;
  } else if (percentageRemaining <= 25) {
    return theme.palette.error.light;
  } else if (percentageRemaining <= 50) {
    return theme.palette.warning.light;
  } else {
    return theme.palette.primary.light;
  }
};
